import { Alert } from "react-bootstrap"

interface ErrorViewProps{
    message: string
    description?: string
}

export const ErrorView = (props: ErrorViewProps) => {
    return (
        <Alert variant="danger" style={{ margin: "30px" }}>
            <Alert.Heading>{props.message}</Alert.Heading>
            {props.description && <p>
                {props.description}
            </p>}
        </Alert>
    )
}